import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {StopPresentation} from "../general/StopPresentation";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {GameData} from "../../../server/data/GameData";
import {PREngineManager} from "../../../punkEngine/PREngineManager";
import {PREngineController} from "../../../punkEngine/PREngineController";
import {SoundManager} from "../../../sound/SoundManager";
import {SoundConfig} from "../../../sound/SoundConfig";
import {PunkRocker} from "../../../PunkRocker";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ReelEngineManager} from "../../../../core/reel/ReelEngineManager";
import {GameSetting} from "../../../../core/setting/GameSetting";
import {ReelState} from "../../../../core/reel/ReelEngineView";
import {AnimationEffects} from "../../../../core/effects/AnimationEffects";
import {gsap, Power3} from "gsap";
import {PunkSymbol} from "../../../punkEngine/symbol/PunkSymbol";
import {BaseModel} from "../../../server/base/BaseModel";
import {PRGameMode} from "../../../server/PRGameMode";

export class NormalStopPresentation extends StopPresentation {

    protected shake: boolean = true;
    protected nextIsFeature: boolean = false;
    private scatterAttentionStart: number = -1;
    private featureBuy: boolean = false;
    private playFeatureBuy: boolean = false;
    private attentionSoundStarted: boolean = false;
    // private changeSize: boolean = true;
    private featureBuyCheckType: string = "LUCKY_DRAW";
    private wildPos: number[] = [];
    private _scatterLandingTL: gsap.core.Timeline | null;
    private _isReelStopSoundPlayed: boolean; // #281

    constructor() {
        super();
        this.featureBuyEventCallback();
    }

    setGamedData(data: GameData): void {
        super.setGamedData(data);
        this.attentionSoundStarted = false;

        this.scatterPos = data.Reel.scatterPositions;
        this.scatterAttentionStart = -1;

        const reelsWithScatter: (number | null)[] = this.scatterPos.map((ele, index) => ele > -1 ? index : null).filter(index => index !== null);

        if (reelsWithScatter.length >= 2) {
            this.scatterAttentionStart = reelsWithScatter[1]!;
        }

        this.wildPos = data.Reel.wildSinglePos;
        // this.deadSpin = this.gameData.Reel.nearWinMap.length <= 2
        this.nextIsFeature = data.nextMode !== GameMode.NORMAL && data.mode === GameMode.NORMAL;
        if (this.featureBuy && BaseModel.buyFeatureName !== this.featureBuyCheckType) {
            this.scatterAttentionStart = -1;
        }
    }

    preStart(): void {
        super.preStart();
    }

    public createPresentation(enableSkip: Function) {
        this._isReelStopSoundPlayed = false;

        enableSkip(!PREngineManager.isQuickStop);

        if (this.readyToDefineStop()) {

            this.createStopSpins();

            const delay: number[] = this.defineDelays();

            PREngineManager.stopReels(delay);

            this.PresentationState.setInactive();
        }
    }

    createStopSpins(): void {
        PREngineManager.RAll((rc: PREngineController) => rc.createStop({
            stops: () => this.onStops(rc),
            bounce: () => this.onBounce(rc),
            stopped: () => this.onStopped(rc)
        }, this.scatterAttentionStart > 0 && rc.reelID > this.scatterAttentionStart && !PREngineManager.isQuickStop));
    }

    defineDelays(): number[] {
        const delay: number[] = this.basicStopDelay;

        if (ReelEngineManager.isQuickStop || GameSetting.isFastSpin) {
            return delay;
        }

        if (this.featureBuy) {
            this.featureBuyDelay(delay);
        } else {
            if (this.scatterDelay(delay)) {
                this.winHitDelay(delay);
            }
            this.featureDelay(delay);
        }

        //#352
        if (PunkRocker.model.gameData.raw.mode === PRGameMode.RESPIN) {
            for (let i: number = 0; i < delay.length; i++) {
                delay[i] += 1;
            }
        }

        return delay;
    }

    featureBuyDelay(delay: number[]): void {
        if (!this.playFeatureBuy || PREngineManager.isQuickStop) {
            return;
        }

        let delays: number = 2.25;
        for (let i: number = 3; i < 6; i++) {
            delay[i] += delays;
            delays += 2;
        }
    }

    scatterDelay(delay: number[]): boolean {
        if (PREngineManager.isQuickStop) {
            return false;
        }

        let delays: number = 0,
            sCount: number = 0;

        for (let i: number = 0; i < delay.length; i++) {
            delay[i] += delays;

            sCount += this.scatterPos[i] >= 0 ? 1 : 0;
            delays += sCount > 1 ? 2 : sCount == 1 ? 0.25 : 0;
        }

        return sCount >= 0;
    }

    winHitDelay(delay: number[]): void {
        if (this.possibleWin.length <= 2) return;
        // let delays: number = 0;
        // for (let i: number = 2; i < delay.length; i++) {
        //     delay[i] += delays;

        //     if (this.possibleWinSymbols.length - 1 > i)
        //         delays += 0.1 + i * 0.1;
        //     else {
        //         delays += 0.1 + i * 0.1;
        //         break;
        //     }
        // }
    }

    featureDelay(delay: number[]): void {
        // if (this.possibleWin.length <= 2) return;
        let delays: number = 0;
        for (let i: number = 0; i < delay.length; i++) {
            delay[i] += delays;

            if (this.gameData.Reel.wildSinglePos[i] >= 0 && this.gameData.Reel.wildSinglePos[i] < 3)
                delays += this.gameData.Reel.wildSinglePos[i] * 0.25 + 0.1;

            if (this.gameData.Reel.mysteryPos[i] >= 0 && this.gameData.Reel.mysteryPos[i] < 3)
                delays += 0.4;
            // else {
            //     delays += 0.1 + i * 0.1;
            //     break;
            // }
        }
    }

    onStops(rc: PREngineController): void {
        rc.setGraphAlpha(0, rc.stopDuration);

        rc.AllWindowSymbols.forEach(s => {
            if (s.isWild) {
                s.stopSpark(rc.stopDuration);
            }
            s.enableDivider(true);
        });
    }

    onBounce(rc: PREngineController): void {
        this.onScatterAnticipation(rc.reelID);

        // #281
        const isQuickStop: boolean = rc.state.equal(ReelState.QUICK_STOP),
            isNormalStop: boolean = !rc.state.equal(ReelState.QUICK_STOP) && !GameSetting.isFastSpin;

        this.playBounceSound(rc.reelID, isNormalStop);
        rc.AllWindowSymbols.forEach(s => {

            // #348 -> don't consider xWild out of visible area
            if (s.isXWild && s.posID[0] > -1 && s.posID[0] < 3) {
                SoundManager.playXWildLandingSound(isQuickStop);
                this.onXWLanding(s, rc.reelID);
            }

            if (s.symName === "M" && s.posID[0] >= 0 && s.posID[0] < rc.windowConfAmount) {
                SoundManager.playXWaysLandingSound(isQuickStop);
            }

            if (!this.gameData.isFreeSpin) {
                if (s.isWild && s.posID[0] >= 0 && s.posID[0] < rc.windowConfAmount) {
                    SoundManager.playWildLandingSound(isQuickStop);
                    s.triggerWild();
                }
            }

            if (this.scatterPos[rc.reelID] === s.posID[0] && s.posID[0] < rc.windowConfAmount) {
                this.countScatter++;
                this.onScatterLanding(rc.reelID, s, this.countScatter);

                if (!(this.countScatter === 1 && rc.reelID === 5)) {
                    this.blackScreenShake(this.countScatter);
                }
                if (this.countScatter === 2) {
                    PunkRocker.waysCounter.showCrazyMessage("!??!!!!???", 2);
                } else if (this.countScatter === 3) {
                    PunkRocker.waysCounter.showCrazyMessage("!?!!??!!???!!?!!!!!!?!", 3);
                }
            } else if (s.isWild) {
                // s.stopSpark();
            }

            this.gameData.stickyJumps.forEach((sData, i) => {
                if (sData.to.x === rc.reelID && sData.to.y === s.posID[0]) {
                    s.jumpWildTransform();
                }
            });

            if (rc.reelID === 4 && this.countScatter >= 2) {
                if (this.gameData.nextMode == GameMode.RESPIN) {
                    PunkRocker.background.changeGraphicAlpha(0.2, 0.4);
                } else if (this.nextIsFeature) {
                    PunkRocker.background.changeGraphicAlpha(0.2, 0.6);
                }
            }
        });

        if (isNormalStop) {
            if (this.wildPos[rc.reelID] >= 0 && this.wildPos[rc.reelID] < rc.windowConfAmount) {
                let startTime = this.animationTl.time() + (GameSetting.isFastSpin ? 0 : 0.1);
                let r = 0;
                const offset: number = GameSetting.isFastSpin ? 0 : 0.25;
                for (let k = this.wildPos[rc.reelID] - 1; k >= 0; k--) {
                    this.animationTl.add(() => {
                        rc.getSymbol(k)!.WildTransform();

                        // #180
                        SoundManager.playWildTransformSound(false);
                    }, startTime + r * offset)
                    this.animationTl.to(this, {duration: 0.75}, startTime + r * offset)
                    r++;
                }
            }
        }
    }

    playBounceSound(reelID: number, isNormalStop?: boolean): void {
        // #281
        if (isNormalStop && !this._isReelStopSoundPlayed) {
            SoundManager.playReelStop(reelID, this.attentionSoundStarted);
        } else if (!this._isReelStopSoundPlayed) {
            this._isReelStopSoundPlayed = true;
            SoundManager.playReelStop(3, this.attentionSoundStarted);
        }

        if (PREngineManager.lastStopOrder === reelID) {
            SoundManager.stopSoundEffect(SoundConfig.REELS_SPINNING);
        }
    }

    onXWLanding(xWildSym: PunkSymbol, reelID: number) {
        xWildSym.playPipeBombAnimation("landing", this.gameData.raw.symbolSizes[reelID][xWildSym.posID[0]], false);
        this.blackScreenShake(2);
    }

    onScatterAnticipation(reelID: number) {
        PREngineManager.getReel(reelID).playAttention(false);
        if (reelID === 5) {
            if (SoundManager.soundPlayer.fetchSoundPlayer(SoundConfig.ANTICIPATION_START)?.isPlaying) {
                SoundManager.stopSoundEffect(SoundConfig.ANTICIPATION_START);
                SoundManager.playSoundEffect(SoundConfig.ANTICIPATION_END);
            }
        }
        if (this.scatterAttentionStart > 0 && this.scatterAttentionStart <= reelID && !PREngineManager.isQuickStop) {
            if (reelID !== (PREngineManager.AllReels.length - 1)) {
                if (reelID <= 4) {
                    PREngineManager.getReel(reelID + 1).playAttention(true);
                }

                if (this.scatterAttentionStart === reelID) {
                    SoundManager.fadeOutAmbient(100, 0.2);
                    this.attentionSoundStarted = true;
                    for (let i: number = 0; i <= reelID; i++) {
                        PREngineManager.getReel(i).AllWindowSymbols.forEach(s => {
                            if (s.isNormalSym) s.markNonWin(true, 0.42, 1.5)
                        });
                    }
                } else {
                    PREngineManager.getReel(reelID).AllWindowSymbols.forEach(s => {
                        if (s.isNormalSym) s.markNonWin(true, 0.42, 1.5)
                    });
                }
            }
        }
    }

    resetPreWins(): void {
        PREngineManager.RSAll((r, s) => s.markNonWin(false, 0, 0.25));
        const startPos: number = this.animationTl.time();
        this.animationTl.to(this, {duration: 0.125}, startPos);
    }

    skip(): void {
        super.skip();
    }

    done(): void {
        super.done();

        if (this.gameData.mode === GameMode.NORMAL) {
            if (this.gameData.gameModeChanges) {
                this.resetPreWins();
            }

            PREngineManager.getReel(0).playAttention(false);
        }
    }

    protected onStopped(currReel: PREngineController): void {
        const startTime: number = this.animationTl.time();

        currReel.AllWindowSymbols.forEach(currSym => {
            if (currSym.isMystery) {
                const reelId: number = currReel.reelID,
                    symId: number = currSym.posID[0],
                    allSymSizes: number[][] = this.gameData.raw.symbolSizes;
                let mysterySize: number = allSymSizes[reelId][symId],
                    totalWays: number = 1;

                // #319
                if (mysterySize > 4) {
                    mysterySize = 4; // because we show x4 on reel stop on super xWays.
                }
                PunkRocker.SYMBOLS_NUM_IN_REEL[currReel.reelID] += (mysterySize - 1); // 1 count is default there
                for (let i: number = 0; i < PunkRocker.SYMBOLS_NUM_IN_REEL.length; i++) {
                    totalWays *= (PunkRocker.SYMBOLS_NUM_IN_REEL[i]);
                }

                PunkRocker.waysCounter.setValue(undefined, totalWays, 0.3);

                this.animationTl.add(currReel.adjustExpandingSymbols(reelId, symId, 0.2, allSymSizes), startTime);

                if (this.gameData.isFreeSpin) {
                    this.gameData.stickyJumps.forEach((sData, i) => {
                        if (sData.to.x === reelId) {
                            this.animationTl.add(() => {
                                PunkRocker.jumpWilds.updateSymbolPositions(i, reelId, sData.to.y, 0.2);
                            }, startTime);
                        }
                    });
                }
            }
        });
    }

    protected blackScreenShake(powAmount: number): void {
        if (!this.shake) return;
        this.shake = false;
        let power: number = Math.min(powAmount, 4);
        const container: PIXI.Container = PunkRocker.background.parent;
        AnimationEffects.Shake({
            x: .2,
            y: 1,
            duration: 0.5 + (power * 0.2),
            hertz: 180 + (power * 60),
            Intensity: 8 + (power * 6.5),
            obj: container,
            positionCb: () => new PIXI.Point(0, 0),
            ease: Power3.easeOut,
            reverseEase: true
        }).play();

        if (power > 1) {
            PunkRocker.background.playAttentionBlackFlash(
                0.4,
                0.3 + (power * 0.1),
                0.4 + power * 0.1,
            ).play();
        }

        // Reel
        gsap.to(this, {
            duration: 0.200,
            onComplete: () => {
                this.shake = true;
            }
        });
    }

    private findScatterInReel(scatterNumber: number) {
        let count = 0;

        for (let i: number = 0; i < this.scatterPos.length; i++) {
            if (this.scatterPos[i] !== -1) {
                count++;
                if (count === scatterNumber) {
                    return i;
                }
            }
        }

        return -1;
    }

    private onScatterLanding(reelId: number, scatterSym: PunkSymbol, scatterCount: number): void {
        const currMode: PRGameMode = this.gameData.mode,
            nextMode: PRGameMode = this.gameData.nextMode,
            isRespinRound: boolean = currMode === PRGameMode.RESPIN,
            isQuickStop: boolean = ReelEngineManager.isQuickStop,
            isFastSpin: boolean = GameSetting.isFastSpin;

        // #399
        //let dontSkipAnim: boolean = !(isQuickStop || isFastSpin);
        let dontSkipAnim: boolean = true;

        this._scatterLandingTL = new gsap.core.Timeline();

        if (scatterCount === 1 || scatterCount === 2) {
            if (!(scatterCount === 1 && reelId === 5)) {
                if (isFastSpin || isQuickStop) {
                    if (scatterCount === 1) {
                        SoundManager.playSoundEffect(SoundConfig.SCATTER_COUNT_1_2);
                    }
                } else {
                    SoundManager.playSoundEffect(SoundConfig.SCATTER_COUNT_1_2);
                }
            }
        } else if (scatterCount === 3 || scatterCount === 4) {
            if (isFastSpin || isQuickStop) {
                if (scatterCount === 3) {
                    SoundManager.playSoundEffect(SoundConfig.SCATTER_COUNT_3_4);
                }
            } else {
                SoundManager.playSoundEffect(SoundConfig.SCATTER_COUNT_3_4);
            }
        } else {
            SoundManager.playSoundEffect(SoundConfig.SCATTER_COUNT_5);
        }

        if (scatterCount === 2 && reelId < 5) {
            SoundManager.playSoundEffect(SoundConfig.ANTICIPATION_START);
        }

        if (isRespinRound) {
            scatterCount = 2;
        }

        if (scatterCount === 1 && reelId === 5) {
            dontSkipAnim = false;
        }

        if (dontSkipAnim || isRespinRound) {
            this._scatterLandingTL.add(scatterSym.playScatterAnim(scatterCount, isRespinRound, false), 0);
        }

        if (!isRespinRound) {
            if (scatterCount > 1 && scatterCount < 5) {
                for (let i: number = scatterCount; i > 0; i--) {
                    const prevScatterReelId: number = this.findScatterInReel(i),
                        prevScatterSymId: number = this.scatterPos[this.findScatterInReel(i)],
                        prevLandedScatterSym: PunkSymbol | undefined = PREngineManager.getReel(prevScatterReelId).getSymbol(prevScatterSymId);

                    if (prevLandedScatterSym) {
                        if (scatterCount === 2) {
                            this._scatterLandingTL.add(prevLandedScatterSym.turnScatterWithSkull(), 0);
                        }

                        if (nextMode !== PRGameMode.RESPIN) {
                            this._scatterLandingTL.add(() => {
                                prevLandedScatterSym.playScatterLoop(scatterCount);
                            });
                        }
                    }
                }
            }

            if (scatterCount === 5) {
                this._scatterLandingTL.add(() => {
                    scatterSym.playScatterLoop(scatterCount);
                });
            }
        }
    }

    private featureBuyEventCallback(): void {
        SlotGame.apiPlugin.events.on(APIEvent.BET, (v: any) => {
            this.featureBuy = !!v.playerInteraction;
            this.playFeatureBuy = this.featureBuy && v.playerInteraction.featureName === this.featureBuyCheckType;
        });
    }
}